export type WicketAdminAudienceFilterOperator =
  | 'is_set'
  | 'is_not_set'
  | 'eq'
  | 'ne'
  | 'gt'
  | 'lt'
  | 'ge'
  | 'le'
  | 'like';
